import type { PaletteOptions } from '@mui/material/styles';

const brand = {
  primary: '#7c5cff',
  secondary: '#37d4a7',
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: { main: brand.primary },
  secondary: { main: brand.secondary },
  background: {
    default: '#0d1017',
    paper: '#151a24',
  },
};

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: { main: '#5b3fd6' },
  secondary: { main: '#12a97f' },
  background: {
    default: '#f6f7fb',
    paper: '#ffffff',
  },
};
